<template>
  <v-row no-gutters ref="mapContainer">
    <map-component :height="getHeight"
                   @go-home="handleGoHome" @map-toolbar-clear="handleUndo"
                   @map-toolbar-undo="handleUndo"
                   @map-created="handleMapCreated"></map-component>
  </v-row>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import {featureToGeojson, geojsonToFeature} from '@/lib/gis-functions'
import 'gox'
import MapComponent from '../Map'
import {buffer} from 'ol/extent'

export default {
  name: 'RouteStartEnd',
  components: {
    MapComponent
  },

  computed: {
    ...mapGetters(['getStartpoint', 'getIcons', 'getNewQuestion', 'getHomeLocation']),
    isNewQuestion() {
      return this.getNewQuestion.qid === 'new'
    },
    mapTitle () {
      return this.startOrEnd === 'start' ? 'Add Start Point' : 'Add End Point'
    },
    startOrEnd() {
      return this.$route.name === 'endPoint' ? 'end' : 'start';
    },
    getHeight() {
      let windowHeight = document.body.offsetHeight;
      let offset = 140;

      return `${windowHeight - offset}px`
    }
  },

  watch: {
    startOrEnd(after, before) {
      this.createLayer();
    },
  },

  mounted() {
    let cont = this.$refs.mapContainer;
    cont.addEventListener("resize", () => {
      if (this.map) {
        this.map.updateSize();
      }
    });
  },

  beforeDestroy() {
    this.map = {};
  },

  data() {
    return {
      map: {},
      drawLayer: null,
      styles: {
        startpoint: () => {
          let style = new GOX.Style();
          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../../../assets/icons/' + this.getIcons.start),
              anchor: [0.5, 48],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        },
        endpoint: () => {
          let style = new GOX.Style();
          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../../../assets/icons/' + this.getIcons.end),
              anchor: [0.5, 48],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        }
      }
    }
  },

  methods: {
    ...mapMutations(['cancelNewQuestion', 'addQuestionStartpoint', 'addQuestionEndpoint']),
    ...mapActions(['CANCEL_CREATE']),
    handleGoHome() {
      var coords = [this.getHomeLocation.lng, this.getHomeLocation.lat];
      var transformed = GOX.Transform(coords, 'EPSG:4326', 'EPSG:27700');
      this.map.setCenter(transformed, 10);
    },
    handleMapCreated(map) {
      this.map = map;
      this.map.updateSize();
      this.handleGoHome();
      this.createLayer();
    },
    handleUndo() {
      console.log("UNDO")
      this.drawLayer.getSource().clear();
      this.drawLayer.startDrawing();
    },
    createLayer() {
      console.log("createLayer: ");

      if (this.drawLayer) {
        this.map.removeLayer(this.drawLayer);
        this.drawLayer = null;
      }

      this.drawLayer = new GOX.Layer.Vector({
        id: 'start-and-end-points',
        geometry: 'Point'
      });

      let geoJSON;
      this.drawLayer.on('draw-end', (e) => {
        geoJSON = featureToGeojson(e.feature);

        console.dir(geoJSON)
        this.drawLayer.getSource().clear();

        if (this.startOrEnd === 'start') {
          this.addQuestionStartpoint(geoJSON);
          this.fetchExistingPoint('startpoint');
        } else {
          this.addQuestionEndpoint(geoJSON);
          this.fetchExistingPoint('startpoint');
          this.fetchExistingPoint('endpoint');
        }

      });

      this.map.addLayer(this.drawLayer);

      console.log("added -- createLayer: ");

      if (this.getNewQuestion.startpoint && this.getNewQuestion.startpoint.length > 0) {
        this.fetchExistingPoint('startpoint');
      }

      if (this.startOrEnd === 'end' && this.getNewQuestion.endpoint && this.getNewQuestion.endpoint.length > 0) {
        this.fetchExistingPoint('endpoint');
      }

      /**
       * If it's a new question, just start drawing.
       */
      if (this.isNewQuestion) {
        console.log("MapStartPoint -- createLayer:  start draw");
        this.drawLayer.startDrawing();
      } else {
        this.drawLayer.startDrawing();

        let extent = this.drawLayer.getFeaturesExtent();

        if (extent[0] === extent[2]) {
          this.map.setExtent(extent, 14);
        } else {
          this.map.setExtent(buffer(extent, 100));
        }
      }

    },
    /**
     * Fetches the existing start or end point
     * @param {string} [type=startpoint] - The type of point to fetch
     */
    fetchExistingPoint(type = 'startpoint') {
      let features = geojsonToFeature(this.getNewQuestion[type])

      features.forEach((feature) => {
        feature.setStyle(this.styles[type]);
        feature.setProperties({
          type: type
        })
      })

      this.drawLayer.getSource().addFeatures(features);
    },
    removeFeaturesOfType(type, exclude) {
      let featuresToRemove = this.drawLayer.getSource().getFeatures().filter(f => {
        return f.get('type') === type
      });

      featuresToRemove.forEach(f => {
        console.dir(exclude)
        console.dir(f)
        if (!exclude || exclude.get('idnr') !== f.get('idnr')) {
          this.drawLayer.getSource().removeFeature(f)
        }
      })
    }
  }
}
</script>

